"use client";

import { cn } from "@gettactic/helpers";
import { cva, type VariantProps } from "class-variance-authority";
import React from "react";

const statusDotVariants = cva("inline-block rounded-full", {
  variants: {
    color: {
      red: "bg-red-500",
      orange: "bg-orange-500",
      yellow: "bg-yellow-500",
      green: "bg-green-500",
      blue: "bg-blue-500",
      purple: "bg-purple-500",
      neutral: "bg-neutral-400"
    },
    size: {
      xs: "h-1.5 w-1.5",
      sm: "h-2 w-2",
      md: "h-2.5 w-2.5",
      lg: "h-3 w-3"
    }
  },
  defaultVariants: {
    color: "neutral",
    size: "md"
  }
});

export interface StatusDotProps
  extends VariantProps<typeof statusDotVariants> {
  className?: string;
}

/**
 * A coloured status dot. Always pair it with text (see `StatusBadge`): colour alone does not
 * say the status.
 */
export const StatusDot: React.FC<StatusDotProps> = ({
  color,
  size,
  className
}) => {
  // Decoration: the status is always said by the text next to it
  return (
    <span
      aria-hidden
      className={cn(statusDotVariants({ color, size }), className)}
    />
  );
};

StatusDot.displayName = "StatusDot";
